<template>
  <div class="service ">
    <headd :mobile_title="mobile_title"></headd>
    <!-- <div class="search container"><img class="icon" />搜索你想要看的公司</div> -->
<div class="order_list container">
      <div class="coupon_title hidden-sm hidden-xs">设计LOGO</div>
      <el-tabs v-model="activeName" @tab-click="handleClickb">
       <el-tab-pane label="全部" name="1"> </el-tab-pane>
        <el-tab-pane label="未完成" name="2"> </el-tab-pane>
        <el-tab-pane label="已完成" name="3"> </el-tab-pane>
    
      </el-tabs>
      
 </div>
  <div class="dddd" v-if="companys.length > 0">
    <div class="box_con ds container" v-for="(item, index) in companys" >
      <div style="flex-direction: column;">
        <div class="info_data">
          <div class="data_head">
            <div class="data_title"><view class="line"></view>设计LOGO</div>
            <div class="data_right">{{ item.design_status }}</div>
          </div>
          <div class="data_cell_list mt35">
            <div class="data_cell">
              <div class="cell_title">设计师</div>
              <div class="cell_con">{{ item.designer }}</div>
            </div>
            <div class="data_cell">
              <div class="cell_title">需求描述</div>
              <div class="cell_con">{{ item.design_desc }}</div>
            </div>
            <div class="data_cell">
              <div class="cell_title">订单</div>
              <div class="cell_con">{{item.design_leixing}}  {{item.design_paynum}}</div>
            </div>
            <div class="data_cell" v-if="item.imgpath">
                    <div class="cell_title">logo图片</div>
                    <div class="cell_con dlogo">
                      <div
                        class="logoimg"
                        :style="{
                          backgroundImage:
                            'url(' + item.imgpath + ')'
                        }"
                      >
                        <img
                          :src="item.imgpath"
                          mode="widthFix"
                        />
                      </div>
                      <div
                        class="item_btn"
                        @click="goView_image(item.imgpath)"
                      >
                        下载
                      </div>
                    </div>
                  </div>
            
          </div>
        </div>
        <div class="btn_list">
          <div class="btnc kefu" @click="kefu(item.recipient_id)">设计师沟通</div>
        </div>
      </div>
    </div>
    </div>
    <div class="list_nodata" v-else>
        <div class="nodata_icon">
          <img src="../../../../static/order/icon_6.png" />
        </div>
        <div class="nodata_text">未查询到订单</div>
    </div>
    <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
  

    <el-dialog :visible.sync="dialogFormVisible" width="7rem">
      <div class="dbox_cell">
        <div
          class="dbox_uploadd"
          v-for="(item, index) in info.imgJson"
          @click="delImg"
          :data-index="index"
          :style="{ backgroundImage: 'url(' + www + item.thumbfilepath + ')' }"
        >
          <img class="delete" src="../../../../static/circle/icon_10.png" />
          <img :src="item.thumbfilepath" class="img" />
        </div>
        <div
          class="dbox_uploadd"
          @click="setImgarr"
          v-show="info.imgJson.length < 1"
        >
          <div class="upload">
            <img src="../../../../static/ruzhu/icon.png" />
          </div>
          <div class="upload_text">上传logo图片</div>
          <div class="upload_tip">只支持.jpg 格式</div>
        </div>
        <div class="btn_save" @click="btn_save">确定</div>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
import { Loading } from "element-ui";
let inputElement = null;
import axios from "axios";
import {
  getmylogolist,
  getkefuchannel,
  getupdateLogoimg
} from "../../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
import { MessageBox, Toast } from "mint-ui";
export default {
  data() {
    return {
      mobile_title: "服务的客户",
      design_id: 0,
      dialogFormVisible: false,
      isChange: -1,
      current: "first",
       activeName: "1",
       tabs: ['全部','未完成', '已完成'],
			orderstatus_type: ['', 'undone','done'],
      banners: [
        {
          id: 1,
          img: "../../../static/user/icon_6.png"
        }
      ],
      pageindex: 1,
      flag: false,
      searchkey: "",
      companys: [],
      info: {
        imgJson: []
      },
      www: this.common.www_img,
      apiurl: this.common.apiurl
    };
  },
  components: { headd, foot },
  mounted() {
    this.getCompanys();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClickb(tab, event) {
      var index = parseInt(tab.name);
      var _self = this;
      _self.orderstatus = _self.orderstatus_type[index - 1];
      _self.companys = [];
      _self.pageindex = 1;
      _self.searchkey=this.searchkey;
      _self.flag = false;
      _self.getCompanys();
    },
    async getkefuchannel() {
      var _self = this;
      var data = { uid: localStorage.getItem("userId") };
      const res = await getkefuchannel(data);
      console.log(res);
      if (res.data.status == 1) {
        //_self.kfid = res.data.data.kfid
        return res.data.data.kfid;
      }
    },
    kefu(recipient) {
      var uid = localStorage.getItem("userId");
      var _self = this;
      var recipient_id = recipient;
      if (recipient_id == 0) {
        console.log(recipient_id);
        _self.getkefuchannel().then(function(result) {
          console.log(result);
          recipient_id = result;
          this.$router.push({
            path: "chat",
            query: {
              uid: uid,
              recipient_id: result
            }
          });
        });
      } else {
        this.$router.push({
          path: "chat",
          query: {
            uid: uid,
            recipient_id: recipient_id
          }
        });
      }
    },
    changeTab(e) {
      var _self = this;

      console.log("当前选中的项：" + e);
      _self.current = parseInt(e);
    },
    async getCompanys() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
         orderstatus: _slef.orderstatus,
        search: _slef.searchkey,
        page: _slef.pageindex,
        limit: 15
      };
      const res = await getmylogolist(data);
      _slef.companys = _slef.companys.concat(res.data.data.logodesigns);
      if (res.data.data.logodesigns.length < 15) {
        _slef.flag = true;
      }
    },debounce(func,wait){
            if(this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(()=>{

                func()

            },wait)
        },

     inputChange(e){
           
            this.debounce(this.getsearch,600)
     },
    
    getsearch() {
      //console.log(value.value);
      //this.search = value.value;
      (this.companys = []),
        (this.pageindex = 1),
        (this.flag = false),
        this.getCompanys();
    },
    open(e) {
      var _self = this;
      var index = e.currentTarget.dataset.index;
      //console.log(index)
      if (index != _self.isChange) {
        _self.isChange = index;
      } else {
        _self.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
      }
    },
    goView_image(url) {
      window.open(url, "_blank");
    },
    goView(urlnew) {
      let url = urlnew;
      console.log(url);
      window.open(url, "_blank");
    },
    setImgarr() {
      var that = this;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("logoimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadLogoImg", formData, config)
              .then(uploadFileRes => {
                //console.log(uploadFileRes.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                console.log(uploadFileRes.data);
                var res = uploadFileRes.data;
                if (res.status == 1) {
                  that.info.imgJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast(res.msg);
                }

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                inputElement = null;
              });
          };
        }
      }
    },
    delImg(e) {
      //console.log(e)
      var _self = this;
      var index = e.currentTarget.dataset.index;
      MessageBox.confirm("是否删除图片")
        .then(action => {
          Toast({
            message: "删除成功"
          });
          var imgJson = _self.info.imgJson;
          imgJson.splice(index, 1);
          _self.info.imgJson = imgJson;
        })
        .catch(() => {
          Toast({
            message: "已取消删除"
          });
        });
    },
    uplogo(id) {
      this.design_id = id;
      this.dialogFormVisible = true;
    },
    async btn_save() {
      var _self = this;
      var data = _self.info;
      //console.log(data)

      if (data.imgJson.length == 0) {
        Toast("请上传图片");
        return false;
      }
      console.log(data.imgJson[0].filepath);
      var parm = {
        uid: localStorage.getItem("userId"),
        design_id: _self.design_id,
        imgpath: data.imgJson[0].filepath
      };
      console.log(parm);
      //return false;
      const res = await getupdateLogoimg(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.design_id = 0;
        _self.info.imgJson = [];
        //_self.$refs.popup.close();
        _self.companys = [];
        _self.pageindex = 1;
        _self.flag = false;
        _self.getCompanys();
        _self.dialogFormVisible = false;
      }
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getCompanys();
      }
    }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.dddd{
		flex-direction: column;
	}
.service {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  border-top: 0.02rem solid #f5f5f5;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
    .container {
      padding: 0;
    }
  }

.list_nodata {
    margin: 1rem 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .nodata_icon {
      width: 3.83rem;
      height: 2.72rem;
      margin: 0rem auto 0.3rem auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nodata_text {
      text-align: center;
      font-size: 0.2rem;
      color: #8d8e99;
      line-height: 0.3rem;
      letter-spacing: 0.01rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }

  .ds {
    margin-top: 0.2rem;
    border: 1px solid #c4c4cc;
    border-radius: 0.2rem;
    padding: 0.2rem 0.32rem;
    width: 8rem;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0.2rem 0.32rem !important;
      border-radius: 0.2rem !important;
    }
  }

.order_list {
  flex-direction: column;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 0;
  }
  margin-top: 0.3rem;
  .coupon_title {
    font-size: 0.26rem;
    margin-bottom: 0.32rem;
    text-align: left;
  }

  .search-input {
    margin: 0 auto 0.34rem auto;
    width: 7.6rem;
    height: 0.4rem;
    @media (max-width: 991px) {
        height: 0.6rem;
        width: 100%;
      }
    background: #ffffff;
    border-radius: 0.3rem;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    display: flex;
    border: 0.01rem solid #c4c4cc;
    background: url(../../../../static/icon/searchicon.png) no-repeat;
    background-size: auto 60%;
    background-position: 0.2rem;
    input {
      width: 100%;
      height: 100%;
      font-size: 0.18rem;
      border: none;
      @media (max-width: 991px) {
        font-size: 0.26rem;
      }
      
    }

  }
}


  .search {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    height: 0.7rem;
    background: #ffffff;
    border-radius: 0.12rem;
    font-size: 0.24rem;
    border: 0.01rem solid #c4c4cc;
    color: #8d8e99;
    align-items: center;
    justify-content: center;
    line-height: 0.7rem;
    .icon {
      width: 0.24rem;
      height: 0.24rem;
    }
  }
}
.uni-searchbar {
  background-color: #f2f2f2;
}
.info_data {
  flex-direction: column;
  text-align: left;
  .data_head {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.07rem;
    padding: 0;

    .data_title {
      height: 0.33rem;
      font-size: 0.2rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.33rem;
      align-items: center;

      .line {
        width: 0.05rem;
        height: 0.26rem;
        background: #1395ff;
        border-radius: 0.03rem;
        margin-right: 0.05rem;
      }
    }

    .arrow_right {
      width: 0.3rem;
      height: 0.17rem;
      display: flex;
      align-items: center;

      img {
        width: 0.3rem;
        height: 0.17rem;
      }
    }

    .data_right {
      font-size: 0.16rem;
      color: #8d8e99;
      line-height: 0.25rem;
      display: flex;

      .right {
        margin-left: 0.1rem;
        font-size: 0.15rem;
        color: #ff545a;
      }
    }
  }

  .data_sn {
    height: 0.25rem;
    font-size: 0.18rem;
    color: #1395ff;
    line-height: 0.25rem;
    margin-top: 0.1rem;
    margin-bottom: 0rem;
    margin-left: 0.08rem;
  }

  .data_cell_list {
    flex-direction: column;

    .data_cell {
      padding: 0;
      margin-bottom: 0.16rem;

      .cell_title {
        width: 1rem;
        line-height: 0.25rem;
        height: 0.25rem;
        font-size: 0.16rem;
        color: #1b1c33;
      }

      .cell_con {
        font-size: 0.16rem;
        color: #000;
        font-weight: normal;
        line-height: 0.25rem;
      }
    }
  }

  .data_table_list {
    width: 100%;
    flex-direction: column;

    .table_head {
      height: 0.4rem;
      line-height: 0.4rem;
      font-weight: bolder;
    }

    .head_25 {
      flex: 1;
      font-size: 0.16rem;
      text-align: center;
      height: 0.4rem;
      line-height: 0.4rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
    }

    .head_50 {
      flex: 2;
      font-size: 0.16rem;
      text-align: center;
      height: 0.4rem;
      line-height: 0.4rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
      border-left: 0;
      border-right: 0;
    }
  }

  .data_img {
    width: 100%;

    .img_item {
      width: 1.4rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        text-align: center;
        width: 1.4rem;
        height: auto;
        vertical-align: middle;
        margin-bottom: 0.2rem;
      }

      .item_btn {
        cursor: pointer;
        width: 0.86rem;
        height: 0.32rem;
        line-height: 0.32rem;
        font-size: 0.14rem;
        text-align: center;
        color: #fff;
        justify-content: center;
        background: #1395ff;
        border-radius: 0.16rem;
      }
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;

    .data_head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.07rem;

      .data_title {
        height: 0.4rem;
        font-size: 0.28rem;

        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.4rem;
        align-items: center;

        .line {
          width: 0.05rem;
          height: 0.26rem;
          background: #1395ff;
          border-radius: 0.03rem;
          margin-right: 0.05rem;
        }
      }

      .arrow_right {
        width: 0.3rem;
        height: 0.17rem;

        img {
          width: 0.3rem;
          height: 0.17rem;
        }
      }

      .data_right {
        font-size: 0.26rem;

        color: #8d8e99;
        line-height: 0.3rem;

        .right {
          margin-left: 0.1rem;
          font-size: 0.28rem;
          color: #ff545a;
        }
      }
    }

    .data_sn {
      height: 0.3rem;
      font-size: 0.26rem;

      color: #1395ff;
      line-height: 0.3rem;
      margin-top: 0.1rem;
      margin-bottom: 0.2rem;
      margin-left: 0.08rem;
    }

    .data_cell_list {
      flex-direction: column;

      .data_cell {
        padding: 0rpx;
        margin-bottom: 0.2rem;

        .cell_title {
          width: 1.66rem;
          line-height: 0.33rem;
          height: 0.33rem;
          font-size: 0.26rem;

          color: #1b1c33;
        }

        .cell_con {
          width: 4.5rem;
          font-size: 0.26rem;

          color: #1b1c33;
          line-height: 0.33rem;
        }
      }
    }

    .data_table_list {
      width: 6.38rem;
      flex-direction: column;

      .table_head {
        height: 0.77rem;
        line-height: 0.77rem;
        font-weight: 600;
      }

      .head_25 {
        flex: 1;
        font-size: 0.26rem;
        text-align: center;
        height: 0.77rem;
        line-height: 0.77rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 1rpx solid rgba(196, 196, 204, 0.5);
      }

      .head_50 {
        flex: 2;
        font-size: 0.26rem;
        text-align: center;
        height: 0.77rem;
        line-height: 0.77rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
        border-left: 0;
        border-right: 0;
      }
    }

    .data_img {
      width: 100%;

      .img_item {
        width: 2.4rem;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          text-align: center;
          width: 2.4rem;
          height: 2.4rem;
          vertical-align: middle;
          margin-bottom: 0.2rem;
        }

        .item_btn {
          width: 1.26rem;
          height: 0.4rem;
          line-height: 0.4rem;
          font-size: 0.24rem;
          text-align: center;
          color: #fff;
          justify-content: center;
          background: #1395ff;
          border-radius: 0.2rem;
        }
      }
    }
  }
}

.btn_list {
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  margin-bottom: 0rpx;
  width: 100%;
  margin-top: 0.2rem;

  .btnc {
    width: 2.7rem;
    height: 0.7rem;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.35rem;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }

  .btnc.kefu {
    background-color: #1395ff;
  }

  .btnc.buy {
    background-color: #f4556c;
  }
}
.img_logo {
  width: 1.4rem;
  height: 1.4rem;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .el-image {
    width: 1.4rem;
    height: 1.4rem;
    opacity: 0;
    @media (max-width: 991px) {
      width: 1.4rem;
      height: 1.4rem;
    }
  }
}
.dbox_cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  flex-direction: column;
  width: 6rem;
  margin: auto;
  height: auto;
  padding: 0.3rem;
  .dbox_uploadd {
    width: 3rem;
    height: 3rem;
    display: flex;
    background: rgba(196, 196, 204, 0.1);
    // border-radius: 22rpx;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    background-size: cover;
    background-position: center;

    .upload {
      width: 1rem;
      height: 0.83rem;
      margin-bottom: 0.23rem;

      img {
        width: 1rem;
        height: 0.83rem;
      }
    }

    .upload_text {
      height: 0.42rem;
      font-size: 0.3rem;

      color: #1b1c33;
      line-height: 0.42rem;
    }

    .upload_tip {
      height: 0.42rem;
      font-size: 0.3rem;

      color: #8d8e99;
      line-height: 0.42rem;
    }

    .delete {
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      width: 0.4rem;
      height: 0.4rem;
    }

    .img {
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .btn_save {
    cursor: pointer;
    margin: 0.5rem auto 0 auto;
    width: 3rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background: #1395ff;
    border-radius: 0.4rem;
    text-align: center;
    font-size: 0.38rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    align-items: center;
    justify-content: center;
  }
}

.dlogo {
  flex-direction: column;

  .logoimg {
    width: 1.4rem;
    height: 1.4rem;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    margin-bottom: 0.2rem;
    img {
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    @media (max-width: 991px) {
      width: 2.4rem;
      height: 2.4rem;
    }
  }
  .item_btn {
    margin-left: 0.3rem;
    cursor: pointer;
    width: 0.86rem;
    height: 0.32rem;
    line-height: 0.32rem;
    font-size: 0.14rem;
    text-align: center;
    color: #fff;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background: #1395ff;
    border-radius: 0.16rem;
    @media (max-width: 991px) {
      margin-left: 0.6rem;
      width: 1.26rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.24rem;
      border-radius: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/logo/logo_list.vue